import { useFormik } from "formik";
import React, { useEffect, useRef } from "react";
import * as Yup from "yup";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import {
  getAllCoinsurace,
  getSingleCoinsurance,
  updateSingleCoinsurance,
} from "../../../redux/slice/coinsurance/coinsuraceSlice";

const EditCoinsuranceCompany = ({ id }) => {
  const closeRef = useRef();
  const dispatch = useDispatch();

  const onSubmit = async (values, { resetForm }) => {
    const payload = {
      data: { ...values },
      id,
    };

    const result = await dispatch(updateSingleCoinsurance(payload));

    // If updateCoinsurance was successful, refetch the list
    if (updateSingleCoinsurance.fulfilled.match(result)) {
      dispatch(getAllCoinsurace({ pageNum: 1 })); // <-- Refetch the list
      resetForm();
      closeRef.current.click();
    }
  };

  const validationScehma = Yup.object().shape({
    company_name: Yup.string("").required("Company name cannot be blank"),
    description: Yup.string("").required("Description cannot be blank"),
  });

  //prefill data
  useEffect(() => {
    if (id) {
      dispatch(getSingleCoinsurance(id));
    }
  }, [id]);

  const { singleCoinsuranceData, isLoading } = useSelector(
    (state) => state.coinsurance
  );

  const {
    values,
    errors,
    touched,
    handleBlur,
    handleChange,
    handleSubmit,
    resetForm,
  } = useFormik({
    enableReinitialize: true,
    initialValues: {
      company_name: isLoading
        ? ""
        : singleCoinsuranceData?.AllCoInsurance?.company_name || "",
      description: isLoading
        ? ""
        : singleCoinsuranceData?.AllCoInsurance?.description || "",
    },
    validationSchema: validationScehma,
    onSubmit,
  });

  useEffect(() => {
    const modalElement = document.getElementById("editCoinsuranceCompany");

    const handleModalHide = () => {
      resetForm(); // clear values and errors
    };

    if (modalElement) {
      modalElement.addEventListener("hidden.bs.modal", handleModalHide);
    }

    return () => {
      if (modalElement) {
        modalElement.removeEventListener("hidden.bs.modal", handleModalHide);
      }
    };
  }, []);

  return (
    <div className="container">
      <div className="my-3 text-start">
        <h3 className="text-dark fs-3">Update Company</h3>
      </div>
      <div>
        <div className="row mb-3">
          <div className="col-sm-12">
            <label for="company_name" className="col-form-label">
              Company Name
            </label>
          </div>
          <div class="col-sm-12">
            <input
              type="text"
              disabled={isLoading}
              name="company_name"
              className="form-control form-control"
              id="company_name"
              value={values?.company_name}
              onChange={handleChange}
              onBlur={handleBlur}
            />
            {errors?.company_name && touched?.company_name && (
              <p className="mb-0 text-danger">{errors?.company_name + "*"}</p>
            )}
          </div>
        </div>
        <div className="row mb-3">
          <div className="col-sm-12">
            <label for="description" className="col-form-label">
              Description
            </label>
          </div>
          <div class="col-sm-12">
            <textarea
              type="text"
              name="description"
              disabled={isLoading}
              className="form-control form-control"
              id="description"
              value={values?.description}
              onChange={handleChange}
              onBlur={handleBlur}
            />
            {errors?.description && touched?.description && (
              <p className="mb-0 text-danger">{errors?.description + "*"}</p>
            )}
          </div>
        </div>
      </div>
      <div className="d-flex justify-content-end gap-1">
        <div className="d-grid">
          <button
            ref={closeRef}
            className="btn btn-sm mt-2 px-3 text-primary"
            data-bs-dismiss="modal"
            style={{ background: "transparent" }}
          >
            Cancel
          </button>
        </div>
        <div className="d-grid">
          <button
            type="submit"
            onClick={handleSubmit}
            className="btn btn-primary btn-sm mt-2 px-3 text-white"
          >
            Update Company
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditCoinsuranceCompany;
